import { render, staticRenderFns } from "./modal-reauth.vue?vue&type=template&id=860f7b84"
import script from "./modal-reauth.vue?vue&type=script&lang=js"
export * from "./modal-reauth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports